<template>
    <!--
        WARNING: Due to highlighting for notes, all added elements must have .exception class
        @see this.findIndex()
    -->
    <div class="section-action-button-container exception">
        <div class="mt-2 section-action-buttons disable-selection no-print" :id="`section-action-buttons-${sectionId}`"
            v-show="visible">
            <!-- Content AIN button -->
            <v-menu
                v-if="contentRestrictions.aiNavigationSectionRestrictions.canShowIcon"
                offset-y
                transition="scale-transition"
                min-width="220">
                <template v-slot:activator="{ on, attrs }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                            <v-btn
                                v-bind="{ ...attrs, ...tooltipAttrs }"
                                v-on="{ ...on, ...tooltipOn }"
                                icon
                                small
                                @click="ainClicked"
                                rounded
                                class="mr-2"
                            >
                                <v-icon class="text--secondary">mdi-navigation-outline</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:default>
                            <div class="py-1 px-3 d-flex align-center">
                                <v-icon
                                    v-if="!contentRestrictions.aiNavigationSectionRestrictions.canUseAiFunctions"
                                    color="white"
                                    small
                                    class="mr-1">
                                    mdi-lock-outline
                                </v-icon>
                                <span>AI Navigator</span>
                            </div>
                        </template>
                    </v-tooltip>
                </template>
                <ain-premium-required-dialog v-if="!hasAiNavAccess" :isDialogActive.sync="displayAinRequiredDialog" />

                <!-- menu content -->
                <v-card v-if="hasAiNavAccess">
                    <v-card-title class="subtitle-2 font-weight-bold pb-2">
                        AI Navigator
                    </v-card-title>
                    <v-list dense>
                        <v-list-item @click="askQuestion">
                            <v-list-item-icon>
                                <v-icon>mdi-message-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Ask question</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="summarizeSection">
                            <v-list-item-icon>
                                <v-icon>mdi-format-list-bulleted</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Summarize section</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
            <ToolBarActionButton
                icon="mdi-content-copy"
                label="Copy text"
                iconClass="trigger-copy-action text--secondary"
                :allowed="contentRestrictions.canCopy"
                @action="$emit('copy')" />

            <ToolBarActionButton
                icon="mdi-bookmark-plus-outline"
                label="Add note or bookmark"
                iconClass="trigger-bookmark-action text--secondary"
                :allowed="contentRestrictions.canBookmark"
                @action="$emit('bookmark')" />

            <ToolBarActionButton
                icon="mdi-printer-outline"
                label="Print"
                iconClass="trigger-print-action text--secondary"
                :allowed="contentRestrictions.canPrint"
                @action="$emit('print')" />

            <ToolBarActionButton
                icon="mdi-link"
                label="Copy link"
                iconClass="trigger-share-action text--secondary"
                :allowed="contentRestrictions.canShare"
                @action="$emit('share')" />
        </div>

        <!-- Mobile Menu Trigger -->
        <div class="mt-2 section-action-button-mobile disable-selection">
            <v-btn
                aria-label="Section Action Menu"
                @click="$emit('fireMobileActions')"
                icon
                text
                rounded
                class="float-right section-action-menu-trigger-mobile">
                <v-icon class="notranslate" aria-hidden="true">
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import ToolBarActionButton from "./ToolBarActionButton.vue";
import AinPremiumRequiredDialog from "./AinPremiumRequiredDialog.vue";

export default {
    emits: ['copy', 'bookmark', 'print', 'share', 'fireMobileActions'],
    components: {
        ToolBarActionButton,
        AinPremiumRequiredDialog
    },
    data() {
        return {
            displayAinMenu: true,
            displayAinRequiredDialog: false
        }
    },
    computed: {
        hasAiNavAccess() {
            return this.contentRestrictions.aiNavigationSectionRestrictions.canShowIcon
            && this.contentRestrictions.aiNavigationSectionRestrictions.canUseAiFunctions;
        }
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: true
        },
        /**
         * @type {ContentRestrictions}
         */
        contentRestrictions: {
            type: Object,
            required: true,
            default: {}
        },
        sectionId: {
            required: true,
            type: Number
        },
    },

    methods: {
        ainClicked() {
            if (!this.hasAiNavAccess) {
                this.displayAinRequiredDialog = true;
            }
        },
        askQuestion() {
            //TODO: implement AI logic
        },
        summarizeSection() {
            //TODO: implement AI logic
        }
    },
}
</script>
